import { useEffect, useState } from "react";
import { getOrganisationIdFromToken } from "../utils/getUserDetails";

const useValidOrganisationCheck = () => {
    const [isValidOrganisation, setIsValidOrganisation] = useState(null);
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState(null);

    useEffect(() => {
        const checkValidOrganisation = async () => {
            try {
                const organisationId = getOrganisationIdFromToken();
                const response = await fetch(
                    `${process.env.REACT_APP_API_URL}/organisation/${organisationId}`
                );
                const data = await response.json();

                if (data.success) {
                    const { isValidOrganisation } = data.result;
                    setIsValidOrganisation(isValidOrganisation);
                } else {
                    setError(data.error?.message || "Failed to validate organisation.");
                }
            } catch (err) {
                console.error("Error:", err);
                setError("An error occurred while validating organisation details.");
            } finally {
                setLoading(false);
            }
        };

        checkValidOrganisation();
    }, []);

    return { isValidOrganisation, loading, error };
};

export default useValidOrganisationCheck;